import { render, staticRenderFns } from "./configuration-automation-protocols-modal-protocols-form.vue?vue&type=template&id=0b6dff58&scoped=true&"
import script from "./configuration-automation-protocols-modal-protocols-form.ts?vue&type=script&lang=ts&"
export * from "./configuration-automation-protocols-modal-protocols-form.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-automation-protocols-modal-protocols-form.scss?vue&type=style&index=0&id=0b6dff58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6dff58",
  null
  
)

export default component.exports